import * as React from 'react';
import { Paper, styled } from '@mui/material';
import { useResponsive } from 'src/hooks/useResponsive';

export type IGlobalLayoutProps = {
    useBackground?: boolean;
    fullHeight?: boolean;
};

const StyledPaper = styled(Paper, {
    shouldForwardProp: prop => prop !== 'fullHeight'
})(({ fullHeight }: { fullHeight: boolean }) => ({
    width: '100%',
    height: fullHeight ? '100%' : 'auto'
}));

export const GlobalLayout = ({
    fullHeight = false,
    useBackground = false,
    children
}: React.PropsWithChildren<IGlobalLayoutProps>) => {
    const { isDesktop } = useResponsive();

    return useBackground && isDesktop ? (
        <StyledPaper fullHeight={fullHeight}>{children}</StyledPaper>
    ) : (
        <div style={{ height: fullHeight ? '100%' : 'auto' }}>{children}</div>
    );
};
